export type Source = {
  library: string
  os_license: string
  license_name: string
}

export const sources: Source[] = [
  {
    library: '@datadog/browser-logs',
    os_license: 'https://github.com/DataDog/browser-sdk/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: '@date-io/date-fns',
    os_license: 'https://github.com/dmtrKovalenko/date-io/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@emotion/react',
    os_license: 'https://github.com/emotion-js/emotion/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@emotion/styled',
    os_license: 'https://github.com/emotion-js/emotion/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@firebase/analytics',
    os_license:
      'https://github.com/firebase/firebase-js-sdk/blob/master/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: '@firebase/app',
    os_license:
      'https://github.com/firebase/firebase-js-sdk/blob/master/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: '@firebase/remote-config',
    os_license:
      'https://github.com/firebase/firebase-js-sdk/blob/master/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: '@mui/icons-material',
    os_license: 'https://github.com/mui/material-ui/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/lab',
    os_license: 'https://github.com/mui/material-ui/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/material',
    os_license: 'https://github.com/mui/material-ui/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/styles',
    os_license: 'https://github.com/mui/material-ui/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/x-date-pickers',
    os_license:
      'https://github.com/mui/mui-x/blob/master/packages/x-date-pickers/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/x-license',
    os_license:
      'https://github.com/mui/mui-x/blob/master/packages/x-license/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/x-tree-view',
    os_license:
      'https://github.com/mui/mui-x/blob/master/packages/x-tree-view/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@nivo/bar',
    os_license: 'https://github.com/plouc/nivo/blob/master/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: '@nivo/core',
    os_license: 'https://github.com/plouc/nivo/blob/master/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: '@nivo/line',
    os_license: 'https://github.com/plouc/nivo/blob/master/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: '@nivo/scatterplot',
    os_license: 'https://github.com/plouc/nivo/blob/master/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: '@react-spring/web',
    os_license: 'https://github.com/pmndrs/react-spring/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@sentry/react',
    os_license:
      'https://github.com/getsentry/sentry-javascript/blob/develop/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@sentry/vite-plugin',
    os_license:
      'https://github.com/getsentry/sentry-javascript-bundler-plugins/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@stytch/react',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: '@stytch/vanilla-js',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: '@tanstack/react-query',
    os_license: 'https://github.com/TanStack/query/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@tanstack/react-query-devtools',
    os_license: 'https://github.com/TanStack/query/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@tanstack/react-query-persist-client',
    os_license: 'https://github.com/TanStack/query/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@testing-library/jest-dom',
    os_license: 'https://github.com/testing-library/jest-dom/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@testing-library/react',
    os_license:
      'https://github.com/testing-library/react-testing-library/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@testing-library/user-event',
    os_license:
      'https://github.com/testing-library/user-event/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@turf/boolean-intersects',
    os_license:
      'https://github.com/Turfjs/turf/blob/master/packages/turf-boolean-intersects/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@turf/helpers',
    os_license:
      'https://github.com/Turfjs/turf/blob/master/packages/turf-helpers/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@turf/intersect',
    os_license: 'https://github.com/Turfjs/turf/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/color',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/dompurify',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: '@types/lodash',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/lodash.clonedeep',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/lodash.debounce',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/lodash.set',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/lodash.throttle',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/point-in-polygon',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/polygons-intersect',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/react-color',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/react-dom',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/react-helmet',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@typescript-eslint/eslint-plugin',
    os_license:
      'https://github.com/typescript-eslint/typescript-eslint/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@typescript-eslint/parser',
    os_license:
      'https://github.com/typescript-eslint/typescript-eslint/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@unicef/material-ui-currency-textfield',
    os_license:
      'https://github.com/unicef/material-ui-currency-textfield/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@use-gesture/react',
    os_license: 'https://github.com/pmndrs/use-gesture/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@vitejs/plugin-react',
    os_license: 'https://github.com/vitejs/vite-plugin-react/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@vitest/coverage-v8',
    os_license: 'https://github.com/vitest-dev/vitest/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@xyflow/react',
    os_license: 'https://github.com/xyflow/xyflow/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'ace-builds',
    os_license: 'https://github.com/ajaxorg/ace-builds/blob/HEAD/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'actions/checkout',
    os_license: 'https://github.com/actions/checkout/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'actions/setup-dotnet',
    os_license: 'https://github.com/actions/setup-dotnet/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'actions/setup-node',
    os_license: 'https://github.com/actions/setup-node/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'array-move',
    os_license: 'https://github.com/sindresorhus/array-move/blob/main/license',
    license_name: 'MIT',
  },
  {
    library: 'aws-amplify',
    os_license: 'https://github.com/aws-amplify/amplify-js/blob/main/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'aws-amplify-react',
    os_license: 'https://github.com/aws-amplify/amplify-js/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'axios',
    os_license: 'https://github.com/axios/axios/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'azure-ai-formrecognizer',
    os_license:
      'https://github.com/Azure/azure-sdk-for-python/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'azure-ai-translation-text',
    os_license:
      'https://github.com/Azure/azure-sdk-for-python/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'babel-loader',
    os_license: 'https://github.com/babel/babel-loader/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'backports.zstd',
    os_license:
      'https://en.wikipedia.org/wiki/Python_Software_Foundation_License',
    license_name: 'PSF',
  },
  {
    library: 'beautifulsoup4',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'black',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'boto3',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'botocore',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'boxdetect',
    os_license: '',
    license_name: '',
  },
  {
    library: 'buffer',
    os_license: 'https://github.com/feross/buffer/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'chardet',
    os_license: 'https://www.gnu.org/licenses/old-licenses/lgpl-2.1.en.html',
    license_name: 'LGPL',
  },
  {
    library: 'ciso8601',
    os_license: 'https://github.com/closeio/ciso8601/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'cloudpathlib',
    os_license:
      'https://github.com/drivendataorg/cloudpathlib/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'cognitojwt',
    os_license: 'https://github.com/borisrozumnuk/cognitojwt/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'color',
    os_license: 'https://github.com/Qix-/color/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'commit-and-tag-version',
    os_license:
      'https://github.com/absolute-version/commit-and-tag-version/blob/HEAD/LICENSE',
    license_name: 'ISC',
  },
  {
    library: 'cropperjs',
    os_license: 'https://github.com/fengyuanchen/cropperjs/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'd3-scale',
    os_license: 'https://github.com/d3/d3-scale/blob/main/LICENSE',
    license_name: 'ISC',
  },
  {
    library: 'date-fns',
    os_license:
      'https://github.com/date-fns/date-fns?tab=readme-ov-file#license',
    license_name: 'MIT',
  },
  {
    library: 'dateparser',
    os_license: 'https://github.com/scrapinghub/dateparser/blob/HEAD/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'DateTime',
    os_license: 'https://spdx.org/licenses/ZPL-2.1.html',
    license_name: 'ZPL 2.1',
  },
  {
    library: 'dayjs',
    os_license: 'https://github.com/iamkun/dayjs/blob/dev/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'djangorestframework-filters',
    os_license:
      'https://github.com/philipn/django-rest-framework-filters/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'djangorestframework-stubs',
    os_license:
      'https://github.com/typeddjango/djangorestframework-stubs/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'dompurify',
    os_license: 'https://github.com/cure53/DOMPurify/blob/HEAD/LICENSE',
    license_name: 'MPL 2.0',
  },
  {
    library: 'eslint',
    os_license: 'https://github.com/eslint/eslint/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'eslint-config-prettier',
    os_license:
      'https://github.com/prettier/eslint-config-prettier/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'eslint-import-resolver-alias',
    os_license:
      'https://github.com/johvin/eslint-import-resolver-alias/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'eslint-plugin-import',
    os_license:
      'https://github.com/import-js/eslint-plugin-import/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'eslint-plugin-jest',
    os_license:
      'https://github.com/jest-community/eslint-plugin-jest/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'eslint-plugin-prettier',
    os_license:
      'https://github.com/prettier/eslint-plugin-prettier/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'eslint-plugin-react',
    os_license:
      'https://github.com/jsx-eslint/eslint-plugin-react/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'eslint-plugin-react-hooks',
    os_license: 'https://github.com/facebook/react/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'fastapi',
    os_license: 'https://github.com/fastapi/fastapi/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'filelock',
    os_license: 'https://unlicense.org',
    license_name: 'Unlicense',
  },
  {
    library: 'filetype',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'future',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'google-auth',
    os_license:
      'https://github.com/googleapis/google-auth-library-python/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'google-cloud-translate',
    os_license:
      'https://github.com/googleapis/google-cloud-python/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'google-cloud-vision',
    os_license:
      'https://github.com/googleapis/google-cloud-python/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'googlemaps',
    os_license:
      'https://github.com/googlemaps/google-maps-services-python/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'husky',
    os_license: 'https://github.com/typicode/husky/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'id128',
    os_license: 'https://github.com/aarondcohen/id128/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'idb-keyval',
    os_license: 'https://github.com/jakearchibald/idb-keyval/blob/main/LICENCE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'intuit-oauth',
    os_license: 'https://github.com/intuit/oauth-jsclient/blob/master/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'jquery',
    os_license: 'https://github.com/jquery/jquery/blob/main/LICENSE.txt',
    license_name: 'MIT',
  },
  {
    library: 'jsdom',
    os_license: 'https://github.com/jsdom/jsdom/blob/main/LICENSE.txt',
    license_name: 'MIT',
  },
  {
    library: 'libphonenumber-js',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'lint-staged',
    os_license: 'https://github.com/okonet/lint-staged/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'lodash.clonedeep',
    os_license:
      'https://github.com/lodash/lodash/blob/npm-packages/lodash.clonedeep/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'lodash.debounce',
    os_license:
      'https://github.com/lodash/lodash/blob/npm-packages/lodash.debounce/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'lodash.set',
    os_license:
      'https://github.com/lodash/lodash/blob/npm-packages/lodash.set/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'lodash.throttle',
    os_license: 'https://github.com/lodash/lodash/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'mangum',
    os_license: 'https://github.com/Kludex/mangum/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'material-react-table',
    os_license:
      'https://github.com/KevinVandy/material-react-table/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'matplotlib',
    os_license: 'https://github.com/matplotlib/matplotlib/blob/HEAD/LICENSE',
    license_name: 'PSF',
  },
  {
    library: 'mmh3',
    os_license: 'https://github.com/hajimes/mmh3/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'model-bakery',
    os_license:
      'https://github.com/model-bakers/model_bakery/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'moto',
    os_license: 'https://github.com/getmoto/moto/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'mxschmitt/action-tmate',
    os_license: 'https://github.com/mxschmitt/action-tmate/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'notistack',
    os_license:
      'https://github.com/iamhosseindhv/notistack/blob/master/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: 'numpy',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'openai',
    os_license: 'https://github.com/openai/openai-python/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'openai-agents',
    os_license:
      'https://github.com/openai/openai-agents-python/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'opencv-python-headless',
    os_license: 'https://github.com/opencv/opencv-python/blob/4.x/LICENSE.txt',
    license_name: 'Apache 2.0',
  },
  {
    library: 'opt-einsum',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'orjson',
    os_license: 'https://github.com/ijl/orjson/blob/master/LICENSE-APACHE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'pdf2image',
    os_license: 'https://github.com/Belval/pdf2image/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'phonenumbers',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'Pillow',
    os_license: 'https://opensource.org/licenses/HPND',
    license_name: 'HPND',
  },
  {
    library: 'pint',
    os_license: 'https://github.com/hgrecco/pint/blob/HEAD/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'point-in-polygon',
    os_license:
      'https://github.com/substack/point-in-polygon/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'prettier',
    os_license: 'https://github.com/prettier/prettier/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'pycodestyle',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'pydantic',
    os_license: 'https://github.com/pydantic/pydantic/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'PyJWT',
    os_license: 'https://github.com/jpadilla/pyjwt/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'PyMuPDF',
    os_license: 'https://www.gnu.org/licenses/agpl-3.0.en.html',
    license_name: 'AGPL',
  },
  {
    library: 'pypdf',
    os_license: 'https://github.com/py-pdf/pypdf/blob/HEAD/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'pypdfium2',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'pypika',
    os_license: 'https://github.com/kayak/pypika/blob/master/LICENSE.txt',
    license_name: 'Apache 2.0',
  },
  {
    library: 'pytest',
    os_license: 'https://github.com/pytest-dev/pytest/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'pytest-django',
    os_license: 'https://github.com/pytest-dev/pytest-django/blob/HEAD/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'pytest-env',
    os_license: 'https://github.com/pytest-dev/pytest-env/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'pytest-mock',
    os_license: 'https://github.com/pytest-dev/pytest-mock/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'pytest-pycodestyle',
    os_license:
      'https://github.com/henry0312/pytest-pycodestyle/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'python-dateutil',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'PyYAML',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'rapidfuzz',
    os_license: 'https://github.com/rapidfuzz/RapidFuzz/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react',
    os_license: 'https://github.com/facebook/react/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-ace',
    os_license:
      'https://github.com/securingsincity/react-ace/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-color',
    os_license: 'https://github.com/casesandberg/react-color/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-cropper',
    os_license:
      'https://github.com/react-cropper/react-cropper/blob/develop/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-dom',
    os_license: 'https://github.com/facebook/react/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-error-boundary',
    os_license:
      'https://github.com/bvaughn/react-error-boundary/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-helmet',
    os_license: 'https://github.com/nfl/react-helmet/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-hook-form',
    os_license:
      'https://github.com/react-hook-form/react-hook-form/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-hotkeys-hook',
    os_license:
      'https://github.com/JohannesKlauss/react-hotkeys-hook/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-image-file-resizer',
    os_license:
      'https://github.com/onurzorluer/react-image-file-resizer/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-markdown',
    os_license: 'https://github.com/remarkjs/react-markdown/blob/main/license',
    license_name: 'MIT',
  },
  {
    library: 'react-number-format',
    os_license:
      'https://github.com/s-yadav/react-number-format/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-router-dom',
    os_license:
      'https://github.com/remix-run/react-router/blob/main/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: 'react-smooth-dnd',
    os_license:
      'https://github.com/kutlugsahin/react-smooth-dnd/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-typing-effect',
    os_license:
      'https://github.com/lamyfarai/react-typing-effect/blob/HEAD/LICENSE',
    license_name: 'ISC',
  },
  {
    library: 'react-zoom-pan-pinch',
    os_license:
      'https://github.com/prc5/react-zoom-pan-pinch/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'requests',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'requests-mock',
    os_license:
      'https://github.com/jamielennox/requests-mock/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'scikit-learn',
    os_license:
      'https://github.com/scikit-learn/scikit-learn/blob/HEAD/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'sentry-sdk',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'seqeval',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'serverless',
    os_license: 'https://github.com/serverless/serverless/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'serverless-cloudformation-sub-variables',
    os_license:
      'https://github.com/santiagocardenas/serverless-cloudformation-sub-variables/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'serverless-lift',
    os_license: 'https://github.com/getlift/lift/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'serverless-plugin-lambda-insights',
    os_license:
      'https://github.com/awslabs/serverless-plugin-lambda-insights/blob/HEAD/LICENSE',
    license_name: 'MIT-0',
  },
  {
    library: 'serverless-plugin-utils',
    os_license:
      'https://github.com/icarus-sullivan/serverless-plugin-utils/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'serverless-prune-plugin',
    os_license:
      'https://github.com/claygregory/serverless-prune-plugin/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'serverless-prune-versions',
    os_license:
      'https://github.com/manwaring/serverless-prune-versions/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'serverless-python-requirements',
    os_license:
      'https://github.com/UnitedIncome/serverless-python-requirements/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'serverless-s3-cleaner',
    os_license:
      'https://github.com/coyoteecd/serverless-s3-cleaner/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'serverless-scriptable-plugin',
    os_license:
      'https://github.com/weixu365/serverless-scriptable-plugin/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'setuptools',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'shapely',
    os_license: 'https://github.com/shapely/shapely/blob/main/LICENSE.txt',
    license_name: 'BSD-3',
  },
  {
    library: 'six',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'smart-open',
    os_license: 'https://github.com/piskvorky/smart_open/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'smartystreets-python-sdk',
    os_license:
      'https://github.com/smartystreets/smartystreets-python-sdk/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'split-pane-react',
    os_license: 'https://github.com/yyllff/split-pane-react/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'starlette',
    os_license: 'https://github.com/Kludex/starlette/blob/main/LICENSE.md',
    license_name: 'BSD-3',
  },
  {
    library: 'stripe',
    os_license: 'https://github.com/stripe/stripe-python/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'stytch',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'svix',
    os_license: 'https://github.com/svix/svix-webhooks/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'sympy',
    os_license: 'https://github.com/sympy/sympy/blob/HEAD/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'tensorboard',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'tensorboardX',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'tiktoken',
    os_license: 'https://github.com/openai/tiktoken/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'toml',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'torch',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'tqdm',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'transformers',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'typescript',
    os_license: 'https://github.com/microsoft/TypeScript/blob/main/LICENSE.txt',
    license_name: 'Apache 2.0',
  },
  {
    library: 'ulid-py',
    os_license: 'https://github.com/ahawker/ulid/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'uuid',
    os_license: 'https://github.com/uuidjs/uuid/blob/main/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: 'uvicorn',
    os_license: 'https://github.com/Kludex/uvicorn/blob/main/LICENSE.md',
    license_name: 'BSD-3',
  },
  {
    library: 'vite',
    os_license: 'https://github.com/vitejs/vite/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'vite-plugin-svgr',
    os_license: 'https://github.com/pd4d10/vite-plugin-svgr/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'vite-tsconfig-paths',
    os_license:
      'https://github.com/aleclarson/vite-tsconfig-paths/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'vitest',
    os_license: 'https://github.com/vitest-dev/vitest/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'weasyprint',
    os_license: 'https://github.com/Kozea/WeasyPrint/blob/HEAD/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'web-vitals',
    os_license: 'https://github.com/GoogleChrome/web-vitals/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
]

export default sources
